<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height >
        <v-layout align-center justify-center>
          <v-flex xs12 sm7 md5>
            <v-form v-on:submit.prevent>
              <v-card class="elevation-12" :loading="enviando">
                <v-toolbar dense dark color="blue-grey darken-3">
                  <v-spacer></v-spacer>
                  <v-toolbar-title class="text-md-center">Sistema de control de oficios</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col xs="6" sm="5" md="5">
                      <img src="logoSG.png" id="imagen">
                    </v-col>
                    <v-col xs="8" sm="7" md="7">

                      <v-text-field 
                        prepend-icon="mdi-account" 
                        name="SG-codigo" 
                        label="Código" 
                        type="text"
                        v-model="codigo" 
                        color="blue-grey"
                        :error-messages="codigoErrors"
                        @input="$v.codigo.$touch()"
                        @blur="$v.codigo.$touch()"
                        >
                      </v-text-field>
                      <v-text-field 
                        prepend-icon="mdi-lock" 
                        name="SG-password" 
                        label="Contraseña" 
                        type="password"
                        color="blue-grey"
                        v-model="password" 
                        :error-messages="passwordErrors"
                        @input="$v.password.$touch()"
                        @blur="$v.password.$touch()"
                        >
                      </v-text-field> 
                      <p class="errorMessage">{{errorMessage}}</p>
                      <!-- <v-checkbox 
                        color="primary" 
                        label="Mantener sesión abierta" 
                        v-model="checkbox"
                      ></v-checkbox> -->
                      <!-- <p>
                        <a class="text-xl-center" href="#" @click="recuperar.mostrar=true">Olvidé mi contraseña</a>
                      </p> -->
                      <p><i>Versión {{version}}</i></p>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="submit"
                    color="blue-grey darken-1"
                    @click="submit()" 
                    dark 
                    :disabled="enviando"
                  >Iniciar sesión</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

    <!-- RECUPERAR CONTRASEÑA -->
    <!-- <v-dialog v-model="recuperar.mostrar" max-width="400">
      <v-card>
        <v-form v-on:submit.prevent>
          <v-card-title class="headline">Recuperar contraseña</v-card-title>

          <v-card-text>
            Para recuperar contraseña, ingrese los siguientes datos:
          </v-card-text>

          <v-card-text>
            <v-text-field 
              prepend-icon="mdi-account" 
              name="login" 
              label="Código" 
              type="text"
              v-model="recuperar.codigo" 
              :error-messages="recCodigoErrors"
              @input="$v.recuperar.codigo.$touch()"
              @blur="$v.recuperar.codigo.$touch()"
              >
            </v-text-field>
            <v-text-field 
              prepend-icon="mdi-email" 
              name="login" 
              label="Correo"  
              type="text"
              v-model="recuperar.email" 
              :error-messages="recEmailErrors"
              @input="$v.recuperar.email.$touch()"
              @blur="$v.recuperar.email.$touch()"
              >
            </v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="recuperar.mostrar = false" >
              Cancelar
            </v-btn>
            <v-btn type="submit" color="primary" @click="recuperarPassword()" >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog> -->


  </v-app>
</template>

<script>
import { mapGetters} from 'vuex'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    name:'Login',
    mixins: [validationMixin],
    components:{
    },
    sockets:{
      conectado(){
        console.log('Conectado al servidor');
      }
    },
    computed: {
        ...mapGetters([
        "httpURL",
        "sessionToken",
        "version"
        ]),
        codigoErrors () {
            const errors = []
            if (!this.$v.codigo.$dirty) return errors
            !this.$v.codigo.required && errors.push('Campo requerido.')
            return errors
        },
        passwordErrors () {
          const errors = []
            if (!this.$v.password.$dirty) return errors
            !this.$v.password.minLength && errors.push('Mínimo 5 caracteres.')
            !this.$v.password.required && errors.push('Campo requerido.')
            return errors
        },
        recCodigoErrors () {
            const errors = []
            if (!this.$v.recuperar.codigo.$dirty) return errors
            !this.$v.recuperar.codigo.minLength && errors.push('Mínimo 5 caracteres.')
            !this.$v.recuperar.codigo.required && errors.push('Campo requerido.')
            return errors
        },
        recEmailErrors () {
            const errors = []
            if (!this.$v.recuperar.email.$dirty) return errors
            !this.$v.recuperar.email.required && errors.push('Campo requerido.')
            !this.$v.recuperar.email.email && errors.push('Correo no válido.')
            return errors
        }
    },
    validations: {
      codigo: { required, minLength: minLength(5) },
      password: { required, minLength: minLength(5) },
      recuperar:{
        codigo: { required, minLength: minLength(5) },
        email: { required },
      }
    },
    data() {
        return {
            enviando: false,
            // checkbox: false,
            codigo:'',
            password: "",
            errorMessage: '',
            recuperar:{
              mostrar: false,
              codigo: null,
              email: null
            }
        }
    },
  created(){
    // this.$socket.emit('disconnect');
    if( sessionStorage.getItem("token") ){
      this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
      this.$router.push('/oficios');
    }
    if( localStorage.getItem("token") ){
      this.$store.dispatch("setSessionToken", localStorage.getItem("token"));
      this.$router.push('/oficios');
    }
  },
  methods:{
    submit() {
      // console.log(this.httpURL);
        this.$v.$touch();
        if( !this.$v.codigo.$invalid && !this.$v.password.$invalid ){
            this.enviando = true;
            axios.post(this.httpURL+'/login',
                {codigo:this.codigo, password:this.password})
                .then(res => {
              
                    if(res.data.ok) {
                        let token = res.data.token;
                        localStorage.setItem("token", token);
                        // this.checkbox ? localStorage.setItem("token",token) : sessionStorage.setItem("token",token);
                        this.$store.dispatch("setSessionToken", token);
                        this.$router.push('/oficios');


                    }
                    else{
                        this.errorMessage = res.data.mensaje;
                        this.enviando = false;
                    }
                })
                .catch(error => {
   
                    this.enviando = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500,
                                text: 'No se pudo establecer una conexión al servidor.' });
                });
      }
    },
    recuperarPassword(){
      this.$v.$touch();
      if( !this.$v.recuperar.codigo.$invalid && !this.$v.recuperar.email.$invalid ){
        // console.log('Se recupera el password');
        this.recuperar.codigo = null;
        this.recuperar.email = null;
        this.recuperar.mostrar = false;
      }
    }
  }
}
</script>

<style>
.errorMessage {
    color: #FF0000
}
.invalid_input{
    border: 1px solid red;
}
</style>